import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchGnbIds } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_GNB_IDS } from '@constants/queryKeys';

const useQueryConsistencyCheckGnbIds = (comparisonId: string) => {
	const {
		data: gnbIdsOptions,
		isLoading,
		isFetching,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [CONSISTENCY_GNB_IDS, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchGnbIds),
		select: (options) => fieldsOptionsFormatted(options.filter(option => option !== null) || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		gnbIdsOptions: gnbIdsOptions || [],
		isLoadingGnbIdsOptions: (isLoading && !!gnbIdsOptions)
			|| isFetching,
	};
};

export default useQueryConsistencyCheckGnbIds;
